import { ImpactFeedbackStyle, impactAsync } from '@/utils/Haptics';

export default function hapticsOnPress<TArgs extends unknown[]>(
  onPress?: (...args: TArgs) => void,
  impactFeedbackStyle: ImpactFeedbackStyle = ImpactFeedbackStyle.Light,
) {
  const onPressIntercept = (...args: TArgs) => {
    if (!onPress) {
      return;
    }

    impactAsync(impactFeedbackStyle);
    onPress(...args);
  };

  return onPressIntercept;
}
